// frontend/src/lib/scheduleTime.js
//
// Auto-schedules are stored and evaluated entirely in UTC (pg_cron's own
// timezone, and the one run-scheduled-comms compares against) — but a
// sender picking "Day / Hour" has no reason to think in UTC, and IST in
// particular is a half-hour-offset zone, so "7 PM my time" cannot even be
// expressed as a whole UTC hour. Rather than build a timezone picker (the
// underlying cron/dispatcher would still need to run in UTC either way),
// this computes what the saved UTC day/hour/minute actually lands on in
// the VIEWER's own local time zone, so the picker stays simple and the
// reader still sees the truth before saving.

const DOW_INDEX = { sun: 0, mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6 };

/** The next UTC instant matching this day-of-week + hour + minute, strictly after now. */
export function nextUtcOccurrence(day_of_week, hour, minute, now = new Date()) {
  const targetDow = DOW_INDEX[day_of_week] ?? 6;
  const h = Number(hour) || 0;
  const m = Number(minute) || 0;

  const candidate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), h, m, 0));
  const dowDiff = (targetDow - candidate.getUTCDay() + 7) % 7;
  candidate.setUTCDate(candidate.getUTCDate() + dowDiff);
  if (candidate.getTime() <= now.getTime()) candidate.setUTCDate(candidate.getUTCDate() + 7);
  return candidate;
}

/** "Wed, 12:30 AM IST" (or whatever the browser's own zone is) for the next occurrence. */
export function localPreview(day_of_week, hour, minute) {
  const when = nextUtcOccurrence(day_of_week, hour, minute);
  return when.toLocaleString(undefined, {
    weekday: "short", hour: "numeric", minute: "2-digit", timeZoneName: "short",
  });
}
